import { render, staticRenderFns } from "./videoToggleWrapper.vue?vue&type=template&id=a5afbad8&"
import script from "./videoToggleWrapper.vue?vue&type=script&lang=js&"
export * from "./videoToggleWrapper.vue?vue&type=script&lang=js&"
import style0 from "./videoToggleWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports